import React, { useEffect, useState, useCallback } from "react";
import './Furioos.css'
import { Player, FS_SDK_EVENTS_NAME } from '../lib/furioos-sdk';
import { useAuth0 } from "@auth0/auth0-react";
import API from "../API";

const Furioos = ({ furioosShareLinkId }) => {
    const [accessToken, setAccessToken] = useState(null);
    const { isAuthenticated, getAccessTokenSilently } = useAuth0();
    const cleanup = useCallback(async () => {
        if (isAuthenticated) {
            const token = await getAccessTokenSilently({
                audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                scope: "ffclient:play",
            });
            //  API.leaveServer(token);
        }
    }, [isAuthenticated, getAccessTokenSilently]);

    useEffect(() => {
        async function loadPlayer() {
            if (isAuthenticated) {
                window.addEventListener("beforeunload", cleanup);
                const token = await getAccessTokenSilently({
                    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                    scope: "ffclient:play",
                });
                setAccessToken(token);

                const player = new Player(furioosShareLinkId, 'furioos_container', {
                    whiteLabel: true,
                    hideTitle: true,
                    hideToolbar: true,
                    hidePlayButton: false,
                    debugAppMode: false,
                    inactiveTimeout: 1500000,
                });
                player.on(FS_SDK_EVENTS_NAME.ON_SESSION_STOPPED, () => {
                    console.log("SDK client FIRED: Session Stopped");
                });      
                player.on(FS_SDK_EVENTS_NAME.ON_SDK_MESSAGE, (data) => {
                    if (data.type === "send-jwt") {
                        player.sendSDKMessage({
                            jwt: token
                        });
                    } else if (data.type === "link") {
                        window.open(data.body,'_blank');
                    }
                });
            }
        }
        loadPlayer();
        return () => {
            cleanup();
            console.log("Cleaning up Furioos component");
            window.removeEventListener("beforeunload", cleanup);
        };
    }, [getAccessTokenSilently, isAuthenticated, furioosShareLinkId, cleanup]);

    return isAuthenticated && accessToken && ( 
        <div className="main-container">
            <div id="furioos_container"></div>
        </div>
    );
};

export default Furioos;
